<template lang="pug">
  help-dialog(:show="visible" @close="visible = false")
    h5 {{$t('management_page.user_remote_approval_process')}}

    p(v-html="$t('management_page.user_remote_approval_policy_activation')")
    p(v-html="$t('management_page.approval_process_applied_policy')")

    .txt-1 {{$t('management_page.approval_process_usage')}}
    .txt-2 {{$t('management_page.approval_process_not_applied_to_existing_exceptions')}}
    .txt-1 {{$t('management_page.approval_process_not_used')}}
    .txt-2 {{$t('management_page.approval_process_disabled_effect')}}
</template>

<script>
import HelpDialog from "@/components/mixins/dialog/help.vue"

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    HelpDialog,
  },
  watch: {
    show(newVal) {
      this.visible = newVal
    },
    visible(newVal) {
      this.$emit("update:show", newVal)
    },
  },
  data() {
    return {
      visible: false,
    }
  },
}
</script>

<style lang="scss" scoped src="./dialog.scss"></style>
